import(/* webpackMode: "eager" */ "/usr/src/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/src/app/src/components/AuthorDetail/IntroSection/bioSection.tsx");
;
import(/* webpackMode: "eager" */ "/usr/src/app/src/components/AuthorDetail/IntroSection/introSection.module.scss");
;
import(/* webpackMode: "eager" */ "/usr/src/app/src/components/AuthorDetail/Breadcrumb/authorBreadcrumb.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/src/app/src/components/AuthorDetail/IntroSection/socialLinks.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/src/app/src/components/AuthorDetail/StoriesSection/storiesSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/src/app/src/components/ErrorBoundary/errorBoundary.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/usr/src/app/src/components/Home/Footer/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/src/app/src/components/Product/ProductNav/headerDesktopAndMweb.tsx");
